// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3DoM_","range":"MonthRangeSwitch_range__2oD-t","disabled":"MonthRangeSwitch_disabled__3WTgB"};